<script lang="ts">
import { defineComponent } from 'vue'
import IndexHero from './Hero.vue'
import IndexMain from './Main.vue'
import IndexAsideSecondary from './AsideSecondary.vue'

export default defineComponent({
  name: 'IndexApp',

  components: {
    IndexHero,
    IndexMain,
    IndexAsideSecondary,
  },
})
</script>

<template>
  <TemplateDefault>
    <template #hero>
      <IndexHero />
    </template>

    <template #main>
      <IndexMain />
    </template>

    <template #asideSecondary>
      <IndexAsideSecondary />
    </template>
  </TemplateDefault>
</template>
